import { stringifyQueryParams } from '@revenuemarket/utils';
import { Dayjs } from 'dayjs';

import { API } from '~apis/axios/instance';
import { AccountTransactionSearchParamFieldType } from '~apis/cash-flow-overview/transactions/AccountTransactionSearchParamFieldType';
import { AbstractBankAccount } from '~models/bank';
import { CashFlowType } from '~models/cashFlow';
import { TransactionsMemoModel } from '~models/transactions/memos';
import { Page, ResponseBaseWithData } from '~types/response';

export interface BankAccountTransaction extends AbstractBankAccount {
  companyId: string;
  accountId: number;
  accountName: string;
  currencyCode: string;
  transactionId: number;
  transactionAt: string;
  transactionDescription: string;
  transactionName: string;
  transactionType: string;
  transactionBranch: string;
  transactionInAmount: number;
  transactionOutAmount: number;
  transactionInKrwAmount: number;
  transactionOutKrwAmount: number;
  transactionAfterBalance: number;
  transactionAfterBalanceKrw: number;
  memo?: TransactionsMemoModel.Memo;
}

export const getBankAccountTransactions = ({
  companyId,
  startDate,
  endDate,
  page,
  accounts,
  searchParam,
  transactionTypes,
  size,
  type,
  sort,
  searchParamFieldTypes,
}: {
  companyId: string;
  startDate: Dayjs;
  endDate: Dayjs;
  accounts?: number[];
  searchParam?: string;
  transactionTypes?: string[];
  page: number;
  size?: number;
  type?: CashFlowType;
  sort?: string[];
  searchParamFieldTypes?: AccountTransactionSearchParamFieldType[];
}) => {
  return API.get<
    ResponseBaseWithData<
      Page<BankAccountTransaction> & {
        transactionInAmountSum: number;
        transactionOutAmountSum: number;
        transactionInOutAmountSum: number;
      }
    >
  >(
    `/api/v3/companies/${companyId}/bank/transactions${stringifyQueryParams({
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
      page,
      accounts,
      searchParam,
      type: type,
      transactionTypes,
      size,
      sort,
      searchParamFieldTypes,
    })}`,
  );
};
